import React, { useEffect, useState } from "react";
import AdminHeader from "../../component/AdminHeader";
import { http } from "../../axios/axios";
import { toast } from "react-toastify";

const TABVALUES = [
  "Home",
  "Product",
  "Blog",
  "Project",
  "Reviews",
  "Careers",
  "Contact",
  "Complaint",
  "Inquiry",
];

const AdminSeo = () => {
  const [activeTab, setActiveTab] = useState("Home");

  const [meta, setMeta] = useState({
    metaTitle: "",
    metaDescription: "",
    metaTags: "",
    canonicalUrl: "",
    schemaScript: "",
  });

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    handleTabChange("Home");
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setMeta((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError("");

      const payload = {
        page: activeTab,
        metaTitle: meta?.metaTitle,
        metaDescription: meta?.metaDescription,
        metaTags: meta?.metaTags
          .split(",")
          .map((tag) => tag.trim())
          .filter(Boolean),
        canonicalUrl: meta?.canonicalUrl,
        schemaScript: meta?.schemaScript,
      };

      const { data } = await http.put("/seo", payload);

      toast.success(data?.message || "SEO updated successfully!");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update SEO.");
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = async (tab) => {
    try {
      setActiveTab(tab);
      setFetching(true);
      setError("");

      const res = await http.get(`/seo/${tab}`);

      const seo = res?.data?.data || res?.data;
      console.log("seo: ",seo)

setMeta({
  metaTitle: seo?.metaTitle || "",
  metaDescription: seo?.metaDescription || "",
  metaTags: Array.isArray(seo?.metaTags)
    ? seo.metaTags.join(", ")
    : "",
  canonicalUrl: seo?.canonicalUrl || "",
  schemaScript: seo?.schemaScript || "",
});
    } catch (err) {
      setMeta({
        metaTitle: "",
        metaDescription: "",
        metaTags: "",
        canonicalUrl: "",
        schemaScript: "",
      });

      setError(err.response?.data?.message || "Unable to fetch SEO.");
    } finally {
      setFetching(false);
    }
  };

  return (
    <div className="p-4 md:p-8 min-h-screen text-slate-200">
      <AdminHeader title="Manage SEO" />

      <div className="grid grid-cols-2 lg:grid-cols-4 2xl:grid-cols-5 gap-2 sm:gap-3 mb-8">
        {TABVALUES.map((tab) => (
          <button
            key={tab}
            onClick={() => handleTabChange(tab)}
            className={`px-4 py-2 rounded-lg transition ${
              activeTab === tab
                ? "bg-blue-600 text-white"
                : "bg-slate-800 text-slate-300 hover:bg-slate-700"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="max-w-7xl mx-auto space-y-6">
        {error && (
          <div className="bg-red-100 text-red-600 p-3 rounded">{error}</div>
        )}

        {fetching && <p className="text-center">Loading meta information...</p>}

        {!fetching && (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2">
                  Meta Title
                </label>

                <input
                  type="text"
                  name="metaTitle"
                  value={meta?.metaTitle}
                  onChange={handleChange}
                  placeholder="Enter Meta Title"
                  className="w-full border px-3 py-2 rounded text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Meta Tags
                </label>

                <input
                  type="text"
                  name="metaTags"
                  value={meta?.metaTags}
                  onChange={handleChange}
                  placeholder="cctv, security, surveillance"
                  className="w-full border px-3 py-2 rounded text-white"
                />

                <p className="text-xs text-gray-400 mt-1">
                  Separate tags with commas.
                </p>
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-2">
                  Meta Description
                </label>

                <textarea
                  name="metaDescription"
                  value={meta?.metaDescription}
                  onChange={handleChange}
                  rows={4}
                  placeholder="Enter Meta Description"
                  className="w-full border px-3 py-2 rounded text-white"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-2">
                  Canonical URL
                </label>

                <input
                  type="text"
                  name="canonicalUrl"
                  value={meta?.canonicalUrl}
                  onChange={handleChange}
                  placeholder="/security-product/cctv-camera-installation-delhi-ncr"
                  className="w-full border px-3 py-2 rounded text-white"
                />

                <p className="text-xs text-gray-400 mt-1">
                  Use a path or full URL. It will be normalized to the live site URL.
                </p>
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-2">
                  Schema Script (JSON-LD)
                </label>

                <textarea
                  name="schemaScript"
                  value={meta?.schemaScript}
                  onChange={handleChange}
                  rows={10}
                  placeholder='{"@context":"https://schema.org","@type":"Organization"}'
                  className="w-full border px-3 py-2 rounded font-mono text-sm text-white"
                />

                <p className="text-xs text-gray-400 mt-1">
                  Paste valid JSON-LD schema here.
                </p>
              </div>
            </div>

            <button
  onClick={handleSubmit}

              disabled={loading}
              className="bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white w-full py-2 rounded"
            >
              {loading ? "Saving..." : `Save ${activeTab} SEO`}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminSeo;
